import React, { useEffect } from 'react';
import './App.css';
import Home from "./pages/home/home";
import { Routes, Route } from "react-router-dom"
import Auth from "./pages/Auth/Auth";
import Singlepost from "./pages/home/singlepost";
import Signin from './pages/Auth/Signin';
import Register from './pages/Auth/Register';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { LOGOUT } from './constants/actionTypes';

function App() {
  const dispatch = useDispatch();
  // adminlogin
  // password: admin@@@Welcome2025
  // email: admin@inspiredformen.com
  const loginUser = useSelector((state) => state.authReducer.authData);
  // console.log("user123", loginUser)



  useEffect(() => {
    // Only run if authData exists (user looks logged in)
    if (loginUser) {
      const checkAuth = async () => {
        try {
          const res = await axios.get('https://api.inspiredformen.com/api/auth/check', {
            withCredentials: true,
          });

          if (!res.data) {
            console.log("⚠️ Session expired or cookie missing. Logging out.");
            dispatch({ type: LOGOUT });
          }
        } catch (err) {
          console.log('🚫 Auth check failed:', err.message);
          dispatch({ type: LOGOUT });
        }
      };

      checkAuth();
    }
  }, [dispatch]); // 👈 only run once on initial load


  return (
    <div>
      {/* <Navbar /> */}
      <Routes>
        <Route exact path='/' caseSensitive={false} element={<Home loginUser={loginUser} />} />
        <Route path='/auth' caseSensitive={false} element={<Auth />} />
        <Route path='/login' caseSensitive={false} element={<Signin />} />
        <Route path='/register' caseSensitive={false} element={<Register />} />
        <Route path='/:topic' caseSensitive={false} element={<Singlepost loginUser={loginUser} />} />
      </Routes>
    </div>
  );
}

export default App;
